/**
 * 文字列か否か
 * @param obj
 * @returns {boolean}
 */
export const isString = (obj)=>{
    return typeof (obj) === "string" || obj instanceof String;
}
